import { MailOutlined } from "@ant-design/icons";
import { useQuery, useMutation } from "@tanstack/react-query";
import { Button, Form, List, message, Modal, Select, Space } from "antd";
import { forwardRef, useImperativeHandle, useState } from "react";
import axios from "axios";
import { hostname } from "../hooks/useEndeavour";
import { set } from "@ant-design/plots/es/core/utils";

export const UsersTagBindingModal = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const query = useQuery({
    queryKey: ["tag-list"],
    queryFn: () => {
      return axios
        .get(`${hostname}/pa-alliance/notification/tag`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          if (res.status !== 200) {
            message.error("Failed to fetch tag list");
            return [];
          }

          let options = res.data.payload.map((item) => ({
            label: item,
            value: item,
          }));

          return options;
        });
    },
  });

  const submit = useMutation({
    mutationFn: (data) => {
      return axios
        .post(`${hostname}/pa-alliance/notification/user/tag`, data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          if (res.status != 200) {
            message.error("Add Fail");
          }
          setLoading(false);
          handleCancel();
          message.success("Add Success");
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  const showModal = (data) => {
    let emailList = [];
    data.forEach((element) => {
      emailList.push(element.email);
    });
    setUsers(emailList);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    form.resetFields();
    setUsers([]);
    setIsModalOpen(false);
  };

  const onFinish = (values) => {
    setLoading(true);
    values.users = users;
    values.action = "create";
    submit.mutate(values);
  };

  useImperativeHandle(
    ref,
    () => ({
      showModal,
    }),
    []
  );

  return (
    <Modal title="User & Tag Combination" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={false}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item name={"tag"} label="Tags" rules={[{ required: true }]}>
          <Select mode="tags" options={query.data} />
        </Form.Item>

        <List
          size="small"
          bordered
          dataSource={users}
          header={<Space style={{ fontWeight: "bold" }}>The selected persons: </Space>}
          renderItem={(item) => (
            <List.Item>
              <Space>
                <MailOutlined /> {item}
              </Space>
            </List.Item>
          )}
          style={{ marginBottom: 16 }}
        />
        <Button htmlType="submit" block type="primary" loading={loading}>
          Create
        </Button>
      </Form>
    </Modal>
  );
});
